import React, { Component } from 'react';
import { InstantSearch, Configure, connectStateResults, connectInfiniteHits, ClearRefinements } from 'react-instantsearch-dom';
import Event from '../components/Event';
import FilterToolbar from '../components/FilterToolbar';
import ByDayHits from '../components/ByDayHits';
import moment from '../utils/momentTimeZone'
import CalendarStripRefinement from '../components/CalendarStripRefinement'
import queryString from 'query-string';
import $ from 'jquery';

const $body = $('body')

const setBodyClassState = (isActive) => {
    if (isActive === true) {
        $body.addClass('state--whatson-showing-results');
    } else {
        $body.removeClass('state--whatson-showing-results')
    }
}

const isActiveSearch = (searchState) => {

    if(searchState) {


        if(searchState.query) {
            setBodyClassState(true)
            return true
        }
        if (searchState.refinementList) {
            for (const filter in searchState.refinementList) {
                if (searchState.refinementList[filter]) {
                    setBodyClassState(true)
                    return true
                }
            }
        }
        if (searchState.range) {
            for (const range in searchState.range) {
                const rangeValue = searchState.range[range]
                if (rangeValue && rangeValue.max) {
                    setBodyClassState(true)
                    return true
                }
            }
        }
    }

    setBodyClassState(false)
    return false
}


const InfiniteHits =  connectInfiniteHits(({ hits, hasMore, refine }) => {
    return (
        <div>
            <div className="c-event-grid">
                {hits.filter(hit => hit.attendable !== undefined).map(hit =>
                    <Event key={hit.objectID} hit={hit} />
                )}
            </div>
            {hasMore && <div className="c-whats-on-LoadMore">
                <button className="c-btn c-btn--red c-btn--small" onClick={refine}>Show more</button>
            </div>}
        </div>
    )
})


const ByEventHits = connectStateResults(({ searchState, searchResults }) => {
    const { hits } = searchResults ? searchResults : {}

    const searchActive = isActiveSearch(searchState)

    if (hits && hits.length >= 0 && searchActive) {
        return (
            <div className="c-event-results">
                <div className="c-container c-container--flush">
                    <div className="c-search-description">
                        <h2 className="c-container-title">Results</h2>
                        <ClearRefinements
                            clearsQuery
                            translations={{
                                reset: 'Clear'
                            }}
                        />
                    </div>

                    {hits.length === 0 && <div className="o-layout o-layout--center">
                        <div className="o-layout__item u-1/1@desktop">
                            <h4 className="fadeIn c-no-events-label">There are no events that match your search criteria</h4>
                        </div>
                    </div>}

                    <InfiniteHits />

                </div>
            </div>
        )
    }
    return null

});

const saveStateToStorage = (key, state) => {
    sessionStorage.setItem(`globe-whatson-searchstate-${key}`, JSON.stringify(state))
}

class FilterView extends Component {

    constructor(props) {
        super(props)

        const parsed = queryString.parse(window.location.search)
        if (parsed) {
            this.filterQuery = parsed.filter
        }

        this.state = {
            day: this.loadSavedStateFromStorage('day'),
            event: this.loadSavedStateFromStorage('event')
        }


        this.construktFeatures = document.getElementById('construkt-features')

        this.onSearchStateChange.bind(this)

    }

    loadSavedStateFromStorage = (key) => {
        const savedState = sessionStorage.getItem(`globe-whatson-searchstate-${key}`)
        const startofDay = moment().startOf('day')

        const defaultState = {
            event: {
                range: {
                    'instances.datetime': { min: moment().unix() },
                }
            },
            day: {
                range: {
                    'unixDay': {min: startofDay.unix(), max: startofDay.add(1, 'week').unix()}
                }
            }
        }

        if (key === 'event' && this.filterQuery) {
            defaultState.event = {
                ...defaultState.event,
                refinementList: {
                    'attendable.eventType': [
                        this.filterQuery
                    ]
                }
            }

            return defaultState.event
        }

        if (savedState) {
            return JSON.parse(savedState)
        } else {
            return defaultState[key]
        }
    }



    componentDidMount = () => {
        this.props.filterComponentHasMounted(true)
    }


  onSearchStateChange = searchState => {

      this.setState({ [this.props.view]: searchState });

      saveStateToStorage(this.props.view, searchState)

      if (this.construktFeatures) {
          this.construktFeatures.style.display = isActiveSearch(searchState) ? 'none' : 'block'
      }

  };

  render() {
      if(this.props.view === 'day') {
          if (this.construktFeatures) {
              this.construktFeatures.style.display = 'none'

          }
      } else if(this.props.view === 'event' && !isActiveSearch(this.state[this.props.view])) {
          if (this.construktFeatures) {
              this.construktFeatures.style.display = 'block'
          }
      }
      return (
          <React.Fragment>
              {this.props.view === 'event' && <InstantSearch
                  appId={window.WP_CONFIG.ALGOLIA_APPLICATION_ID}
                  apiKey={window.WP_CONFIG.ALGOLIA_SEARCH_API_KEY}
                  searchState={this.state.event}
                  indexName={"wp_posts_event"}
                  onSearchStateChange={this.onSearchStateChange}
              >
                  <Configure hitsPerPage={12} />
                  <FilterToolbar />
                  <ByEventHits />
              </InstantSearch>}
              {this.props.view === 'day' && <InstantSearch
                  appId={window.WP_CONFIG.ALGOLIA_APPLICATION_ID}
                  apiKey={window.WP_CONFIG.ALGOLIA_SEARCH_API_KEY}
                  searchState={this.state.day}
                  indexName={'events_by_day'}
                  onSearchStateChange={this.onSearchStateChange}
              >
                  <Configure hitsPerPage={999} />
                  <CalendarStripRefinement searchState={this.state.day} attribute="unixDay" />
                  <section style={{zIndex: 1}}>
                      <ByDayHits dateRange={this.state.day} />
                  </section>
              </InstantSearch>}
          </React.Fragment>
      );
  }
}
export default FilterView;



// WEBPACK FOOTER //
// ./src/whatson/views/FilterView.js